import FontFaceObserver from 'fontfaceobserver'
import { useEffect } from 'react'

const Fonts = () => {
  const fontClassName = 'Lato'

  useEffect(() => {
    if (document.querySelector('html').className.includes(fontClassName)) return

    const link = document.createElement('link')
    link.href = `https://fonts.googleapis.com/css?family=${fontClassName}:ital,300,400,500,700,900&display=swap`
    link.rel = 'stylesheet'

    document.head.appendChild(link)

    const Lato = new FontFaceObserver(fontClassName)

    Lato.load().then(() => {
      document.documentElement.classList.add(fontClassName)
    })
  })

  return null
}

export default Fonts
